module.exports = __webpack_public_path__ + "static/media/local_activity_white.ce9a2f08.svg";